import { useTranslation } from "react-i18next";
import { useFormState } from "react-final-form";
import FormControl from "common/components/FormControl/FormControl";
import SectionTitle from "common/components/SectionTitle/SectionTitle";
import ToggleSwitch from "common/components/ToggleSwitch/ToggleSwitch";
import { useEffect } from "react";

interface NotificationsToggleSectionProps {
  notifications: string[];
  form: any;
  editable: boolean;
}

function NotificationsToggleSection({
  notifications,
  form,
  editable,
}: NotificationsToggleSectionProps) {
  const { t } = useTranslation();
  const { values } = useFormState();

  useEffect(() => {
    if (values.notificationSettings) {
      const areAllChecked = notifications.every(
        (notification) =>
          values.notificationSettings[notification]?.push === true
      );
      form.change(`notificationSettings.all`, areAllChecked);
    }
  }, [values, notifications, form]);

  const handleToggleAll = (checked: boolean) => {
    notifications.forEach((notification) => {
      form.change(`notificationSettings.${notification}.push`, checked);
    });
  };

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-row gap-3 items-center">
        <SectionTitle
          title={t("forms.notificationSettings")}
          className="text-lg normal-case"
        />
        <FormControl
          type="custom"
          name="notificationSettings.all"
          editable={editable}
          onChange={handleToggleAll}
        >
          <ToggleSwitch isDisabled={!editable} />
        </FormControl>
      </div>
      <div className="flex flex-row flex-wrap gap-4">
        {notifications.map((notification) => (
          <FormControl
            key={`notificationSettings.${notification}`}
            type="custom"
            editable={editable}
            name={`notificationSettings.${notification}.push`}
          >
            <ToggleSwitch
              rightLabel={t(`notificationSettings.${notification}`)}
            />
          </FormControl>
        ))}
      </div>
    </div>
  );
}

export default NotificationsToggleSection;
